import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton } from "@ionic/react";

// css
import "../Shared.css";
import "../../App.css";
import "./SignificantChangeWarningCard.css";

// controllers
import { IScreenProps, IUser, IGuideline, IGuidelineSummary, IAlgorithm, ISignificantChange } from "../Interfaces";
import DataController from "../controllers/DataController";

// images
import disclosureRight from "../assets/Button_Disclosure_Right_Grey50@3x.png";
import indicatorUpdate from "../assets/Indicator_Update@3x.png";

type Props = {
  significantChange: ISignificantChange;
  acknowledged: boolean;
  showAcknowledgeButton: boolean;
  acknowledgeButtonClicked?: (significantChange: ISignificantChange) => void;
};
type State = {};

class SignificantChangeWarningCard extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  acknowledgeButtonClicked(event: React.MouseEvent) {
    try {
      event.stopPropagation();
    } catch (error) {
      console.log(error);
    }

    if (this.props.acknowledgeButtonClicked) {
      this.props.acknowledgeButtonClicked(this.props.significantChange);
    }
  }

  render() {
    let titleText = this.props.significantChange.title;
    let dateText = this.props.significantChange.updated.date;
    let descriptionHtml = this.props.significantChange.description;

    let significantChangeTrust = this.props.significantChange.trust;
    let significantChangeTrustSection = "";
    if (significantChangeTrust == null || significantChangeTrust === "JRCALC") {
      significantChangeTrust = "JRCALC";
      significantChangeTrustSection = DataController.getSectionClass("SignificantChangeJRCALC");
    } else {
      significantChangeTrustSection = DataController.getSectionClass(significantChangeTrust);
    }

    return (
      <div className="significantChangeWarningCard">
        <div className="significantChangeWarningCardContents">
          <div className="significantChangeWarningCardDate">
            <div className="significantChangeWarningCardUpdate">UPDATE</div>
            {dateText}
            <div className="significantChangeCellTrustDotSeparator" />
            <div className={`significantChangeCellTrust ${significantChangeTrustSection}`}>
              {significantChangeTrust}
            </div>
          </div>
          <div className="significantChangeWarningCardTitle">{titleText}</div>

          <div
            className="significantChangeWarningCardDescription"
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />

          {this.props.showAcknowledgeButton ? (
            <IonButton
              className="significantChangeWarningCardAcknowledgeButton filledButton"
              onClick={(event) => this.acknowledgeButtonClicked(event)}
            >
              Acknowledge
            </IonButton>
          ) : null}
        </div>
      </div>
    );
  }
}

export default SignificantChangeWarningCard;
